import { on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ConsumerTypesActions } from './consumer-types.actions';
import { ConsumersAsyncActions } from './consumer-types.actions';
import {ConsumerType} from '@emm/core/models/consumer-type.model';
import {asyncActionState, AsyncActionState} from '@emm/core/util/async-action-state';
import {withLoadables} from '@emm/core/util/ngrx.util';

export const consumerTypesFeatureKey = 'consumerTypes';

export interface ConsumerTypesState extends EntityState<ConsumerType>, AsyncActionState {}

export const adapter: EntityAdapter<ConsumerType> = createEntityAdapter<ConsumerType>({
    selectId: (item: ConsumerType) => item.tag,
    sortComparer: null
});

export const initialState: ConsumerTypesState = adapter.getInitialState({
    ...asyncActionState.initial
});

const { loadActions, successActions, errorActions } = ConsumersAsyncActions;

export const consumerTypesReducer = withLoadables<ConsumerTypesState>({
    loadActions,
    successActions,
    errorActions
})(
    initialState,

    on(ConsumerTypesActions.loadAllSuccess, (state: ConsumerTypesState, { consumerTypes }) =>
        adapter.setAll(consumerTypes, state)
    )

);
